export default "__VITE_ASSET__BDllIq4q__"